import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import SimpleAlert from "../../../components/display/SimpleAlert";
import Skeletons from "../../../components/loader/Skeletons";
import MobileViewer from "../../../components/wrappers/MobileViewer";
import useGetAppointments from "../../../hooks/useGetAppointments";
import { getDateObject } from "../../../utils/DateTimeRepository";
import SingleAppointment from "../../appointments/components/display/SingleAppointment";
import FutureAppointment from "./FutureAppointment";
import { STATUSES } from "../../../enums/AppointmentStatus";
//TODO: move this to the backend has not use being on the frontend
const parseDateString = (date) => dayjs(getDateObject(date));
const today = dayjs();
function getFutureAppointements(data) {
  if (data != null && data != undefined) {
    return data?.filter(
      (appointment) =>
        parseDateString(appointment.startDate)
          .startOf("day")
          .isAfter(today.startOf("day")) &&
        appointment.status != STATUSES.INACTIVE &&
        appointment.status != STATUSES.FINISHED &&
        appointment.status != STATUSES.RESOLVED
    );
  }
}

function getTodaysAppointements(data) {
  if (data != null && data != undefined) {
    return data?.filter(
      (appointment) =>
        parseDateString(appointment.startDate)
          .startOf("day")
          .isSame(today.startOf("day")) &&
        appointment.status != STATUSES.INACTIVE &&
        appointment.status != STATUSES.FINISHED &&
        appointment.status != STATUSES.RESOLVED
    );
  }
}

function InfoStrip({ title, color }) {
  const { t } = useTranslation();
  return (
    <Typography
      style={{
        backgroundColor: color,
        color: "white",
        paddingLeft: 8,
        borderRadius: 2,
      }}
    >
      {`${t(title)}`}
    </Typography>
  );
}

function Future({ title }) {
  return <InfoStrip title={title} color={"#fb8500"} />;
}
function Today({ title }) {
  return <InfoStrip title={title} color={"#219ebc"} />;
}

export default function MobileAppointement() {
  const { data, isLoading, error } = useGetAppointments();
  const { t } = useTranslation();

  if (isLoading) {
    return <Skeletons grid={false} height={150} numOfSkeletons={6} />;
  } else if (error && !isLoading) {
    return (
      <SimpleAlert severity={"error"} message={"ErrorFetchingAppointments"} />
    );
  }

  function noAppointementsToday() {
    return <Today title={"NoAppointmentsForToday"} />;
  }

  function noFutureAppointments() {
    return <Future title={"NoFutureAppointments"} />;
  }

  const todays = getTodaysAppointements(data)?.length;
  const future = getFutureAppointements(data)?.length;

  return (
    <MobileViewer>
      <Fragment>
        <Stack>
          <>
            {todays == 0 ? (
              noAppointementsToday()
            ) : (
              <>
                <Today
                  title={`${t("TodaysAppointments")} (${dayjs().format(
                    "DD/MM/YYYY"
                  )})`}
                />

                {getTodaysAppointements(data)?.map((item) => (
                  <SingleAppointment appointment={item} key={item.id} />
                ))}
              </>
            )}
          </>
        </Stack>
        <>
          <Stack spacing={2}>
            {future === 0 ? (
              noFutureAppointments()
            ) : (
              <>
                <Future title={"FutureAppointments"} />
                {getFutureAppointements(data)
                  ?.slice(0, 3)
                  ?.map((item) => (
                    <FutureAppointment
                      key={item.id}
                      appointement={item} // Fixed typo from "appointement" to "appointment"
                      marginTop={0.5}
                    />
                  ))}
              </>
            )}
          </Stack>
        </>
      </Fragment>
    </MobileViewer>
  );
}
